import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { SqlPool, LinkedService } from 'shell-models-lib';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sqlPool.datasetType
})
export class SqlPoolTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL,
        constraint: {
            required: false // overwrite base dataset
        }
    })
    public linkedService: LinkedService;

    @Metamodel.attribute({
        reference: true,
        type: SqlPool.MODEL,
        display: stringResources.AzureSQLAnalyticsPool_DisplayText,
        constraint: {
            required: true
        }
    })
    public sqlPool: SqlPool;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
